



























































import { defineComponent, PropType } from "vue";
import BulletList from "./BulletList.vue";

type AlertType = "info" | "danger" | "success" | "warning" | "rewards" | "voucher" | undefined;

export default defineComponent({
    name: "AlertMessage",
    components: {
        BulletList
    },
    props: {
        title: {
            type: String,
            required: true
        },
        boldTitle: {
            type: Boolean,
            default: true
        },
        collapseTitle: {
            type: String,
            default: undefined
        },
        collapseId: {
            type: String,
            default: undefined
        },
        text: {
            type: String as PropType<string | null>,
            default: null
        },
        items: {
            type: Array as PropType<string[] | null>,
            default: null
        },
        withButton: {
            type: Boolean,
            default: false
        },
        labelButton: {
            type: String,
            default: ""
        },
        urlButton: {
            type: String,
            default: ""
        },
        isMini: {
            type: Boolean,
            default: false
        },
        type: {
            type: String as PropType<AlertType>,
            default: undefined
        },
        anonymized: {
            type: Boolean,
            default: false
        },
        withAlertRole: {
            type: Boolean,
            default: false
        },
        dataTestId: {
            type: String as PropType<string | null>,
            default: null
        },
        noBackground: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        alertContainerClasses(): string[] {
            if (this.isMini) {
                return ["alert-container", "alert-container-sm"];
            } else {
                return ["alert-container"];
            }
        },
        alertClass(): string | null {
            switch (this.type) {
                case "info":
                    return "alert-info";
                case "danger":
                    return "alert-danger";
                case "success":
                    return "alert-success";
                case "warning":
                    return "alert-warning";
                default:
                    return null;
            }
        },
        alertIconClass(): string {
            switch (this.type) {
                case "info":
                    return "icon-info";
                case "danger":
                    return "icon-error-severe";
                case "success":
                    return "icon-tick-circle";
                case "warning":
                    return "icon-warning-important";
                case "rewards":
                    return "icon-rewards";
                case "voucher":
                    return "icon-voucher-tag";
                default:
                    return "icon-info";
            }
        },
        buttonClass(): string {
            if (this.isMini) {
                return "ob1-link-small";
            } else {
                return "ob1-link";
            }
        }
    }
});
